import { SagaIterator } from 'redux-saga'
import { takeEvery, call } from 'redux-saga/effects'
import { getConfiguration } from '../configuration/index'

import { validateCode, redeemCode, LoadCouponCodeResultSuccess, ValidateCodeResultSuccess, ValidateCodeResultFailure } from '../api/actions'

function* handleValidateCodeDone(action: ValidateCodeResultSuccess): SagaIterator {
  const { couponCode, linkedId, linkedType, onComplete } = action.payload.params
  const { status } = action.payload.result

  if (status === 'invalid' || status === 'expired') {
    try {
      const projectId = getConfiguration().getDefaultAppInfo().projectId
      yield call(getConfiguration().removeCouponCodeFromDisk, projectId, {
        code: couponCode,
        linkedId,
        linkedType,
      })
    } catch (error) {
      // Error deleting old data
    }
    onComplete?.(false)
  } else {
    onComplete?.(true)
  }
}

function* handleValidateCodeFailed(action: ValidateCodeResultFailure): SagaIterator {
  const { couponCode, linkedId, linkedType, onComplete } = action.payload.params

  try {
    const projectId = getConfiguration().getDefaultAppInfo().projectId
    yield call(getConfiguration().removeCouponCodeFromDisk, projectId, {
      code: couponCode,
      linkedId,
      linkedType,
    })
  } catch (error) {
    // Error deleting old data
  }
  onComplete?.(false)
}

function* handleRedeemCodeDone(action: LoadCouponCodeResultSuccess): SagaIterator {
  const { couponCode, linkedId, linkedType } = action.payload.params
  const { status, expire_after } = action.payload.result
  
  if (status === 'valid') {
    try {
      const projectId = getConfiguration().getDefaultAppInfo().projectId
      yield call(getConfiguration().saveCouponCodeToDisk, String(projectId), {
        code: couponCode,
        linkedId,
        linkedType,
        expireAt: expire_after && (Date.now() + 1000 * 60 * 60 * expire_after),
      })
    } catch (error) {
      // Error saving data
    }
  }
}

export default function* (): SagaIterator {
  yield takeEvery(validateCode.done, handleValidateCodeDone)
  yield takeEvery(validateCode.failed, handleValidateCodeFailed)
  yield takeEvery(redeemCode.done, handleRedeemCodeDone)
}